var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.containerId},[_c('table',{class:_vm.tableClass,attrs:{"id":"dataTable","cellspacing":"0","width":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }